export const GET_USERS_REQUEST = "GET_USERS_REQUEST";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAILED = "GET_USERS_FAILED";

export const GET_PRACTIONERS_REQUEST = "GET_PRACTIONERS_REQUEST";
export const GET_PRACTIONERS_SUCCESS = "GET_PRACTIONERS_SUCCESS";
export const GET_PRACTIONERS_FAILED = "GET_PRACTIONERS_FAILED";

export const GET_INVITE_REQUEST = "GET_PRACTIONERS_REQUEST";
export const GET_INVITE_SUCCESS = "GET_PRACTIONERS_SUCCESS";
export const GET_INVITE_FAILED = "GET_PRACTIONERS_FAILED";

export const USERS_DETAILS_REQUEST = "USERS_DETAILS_REQUEST";
export const USERS_DETAILS_SUCCESS = "USERS_DETAILS_SUCCESS";
export const USERS_DETAILS_FAILED = "USERS_DETAILS_FAILED";

export const USERS_REMOVE_REQUEST = "USERS_REMOVE_REQUEST";
export const USERS_REMOVE_SUCCESS = "USERS_REMOVE_SUCCESS";
export const USERS_REMOVE_FAILED = "USERS_REMOVE_FAILED";

export const PATIENT_REMOVE_REQUEST = "PATIENT_REMOVE_REQUEST";
export const PATIENT_REMOVE_SUCCESS = "PATIENT_REMOVE_SUCCESS";
export const PATIENT_REMOVE_FAILED = "PATIENT_REMOVE_FAILED";

export const PRACTIONERS_DETAILS_REQUEST = "PRACTIONERS_DETAILS_REQUEST";
export const PRACTIONERS_DETAILS_SUCCESS = "PRACTIONERS_DETAILS_SUCCESS";
export const PRACTIONERS_DETAILS_FAILED = "PRACTIONERS_DETAILS_FAILED";

export const GET_ALL_USERS_REQUEST = "GET_ALL_USERS_REQUEST";
export const GET_ALL_USERS_SUCCESS = "GET_ALL_USERS_SUCCESS";
export const GET_ALL_USERS_FAILED = "GET_ALL_USERS_FAILED";

export const GET_INVITED_USERS_REQUEST = "GET_INVITED_USERS_REQUEST";
export const GET_INVITED_USERS_SUCCESS = "GET_INVITED_USERS_SUCCESS";
export const GET_INVITED_USERS_FAILED = "GET_INVITED_USERS_FAILED";

export const GET_MY_PATIENT_DETAILS_REQUEST = "GET_MY_PATIENT_DETAILS_REQUEST";
export const GET_MY_PATIENT_DETAILS_SUCCESS = "GET_MY_PATIENT_DETAILS_SUCCESS";
export const GET_MY_PATIENT_DETAILS_FAILED = "GET_MY_PATIENT_DETAILS_FAILED";

export const SENT_INVITE_REQUEST = "SENT_INVITE_REQUEST";
export const SENT_INVITE_SUCCESS = "SENT_INVITE_SUCCESS";
export const SENT_INVITE_FAILED = "SENT_INVITE_FAILED";
export const USER_STATUS_UPDATE_REQUEST = "USER_STATUS_UPDATE_REQUEST";
export const USER_STATUS_UPDATE_SUCCESS = "USER_STATUS_UPDATE_SUCCESS";
export const USER_STATUS_UPDATE_FAILED = "USER_STATUS_UPDATE_FAILED";

export const GET_USERS_EMAIL_REQUEST = "GET_USERS_EMAIL_REQUEST";
export const GET_USERS_EMAIL_SUCCESS = "GET_USERS_EMAIL_SUCCESS";
export const GET_USERS_EMAIL_FAILED = "GET_USERS_EMAIL_FAILED";

export const GET_PRACTITIONERS_EMAIL_REQUEST =
  "GET_PRACTITIONERS_EMAIL_REQUEST";
export const GET_PRACTITIONERS_EMAIL_SUCCESS =
  "GET_PRACTITIONERS_EMAIL_SUCCESS";
export const GET_PRACTITIONERS_EMAIL_FAILED = "GET_PRACTITIONERS_EMAIL_FAILED";

export const GET_USER_PROGRAM_GRAPH_REQUEST = "GET_USER_PROGRAM_GRAPH_REQUEST";
export const GET_USER_PROGRAM_GRAPH_SUCCESS = "GET_USER_PROGRAM_GRAPH_SUCCESS";
export const GET_USER_PROGRAM_GRAPH_FAILED = "GET_USER_PROGRAM_GRAPH_FAILED";

export const GET_USER_WATCH_GRAPH_REQUEST = "GET_USER_WATCH_GRAPH_REQUEST";
export const GET_USER_WATCH_GRAPH_SUCCESS = "GET_USER_WATCH_GRAPH_SUCCESS";
export const GET_USER_WATCH_GRAPH_FAILED = "GET_USER_WATCH_GRAPH_FAILED";

export const GET_MAINTENANCE_MODE_REQUEST = "GET_MAINTENANCE_MODE_REQUEST"
export const GET_MAINTENANCE_MODE_SUCCESS = "GET_MAINTENANCE_MODE_SUCCESS"
export const GET_MAINTENANCE_MODE_FAILED = "GET_MAINTENANCE_MODE_FAILED"

export const MAINTENANCE_MODE_REQUEST = "MAINTENANCE_MODE_REQUEST"
export const MAINTENANCE_MODE_SUCCESS = "MAINTENANCE_MODE_SUCCESS"
export const MAINTENANCE_MODE_FAILED = "MAINTENANCE_MODE_FAILED"

export const getUsersDataAction = (data) => {
  return { type: GET_USERS_REQUEST, payload: data };
};

export const getPractionersDataAction = (data) => {
  return { type: GET_PRACTIONERS_REQUEST, payload: data };
};

export const getInviteDataAction = (data) => {
  return { type: GET_INVITE_REQUEST, payload: data };
};

export const getUsersDetailsAction = (data) => {
  return { type: USERS_DETAILS_REQUEST, payload: data };
};

export const getPractionersDetailsAction = (data) => {
  return { type: PRACTIONERS_DETAILS_REQUEST, payload: data };
};

export const getAllUsersDataAction = (data) => {
  return { type: GET_ALL_USERS_REQUEST, payload: data };
};

export const getInvitedUsersDataAction = (data) => {
  return { type: GET_INVITED_USERS_REQUEST, payload: data };
};

export const getPractitionersEmailAction = (data) => {
  return { type: GET_PRACTITIONERS_EMAIL_REQUEST, payload: data };
};

export const getMyPatientDetails = (data) => {
  return { type: GET_MY_PATIENT_DETAILS_REQUEST, payload: data };
};

export const sentInviteAction = (data) => {
  return { type: SENT_INVITE_REQUEST, payload: data };
};
export const userRemoveAction = (data) => {
  return { type: USERS_REMOVE_REQUEST, payload: data };
};
export const patientRemoveAction = (data) => {
  return { type: PATIENT_REMOVE_REQUEST, payload: data };
};
export const updateUserStatusAction = (data) => {
  return { type: USER_STATUS_UPDATE_REQUEST, payload: data };
};
export const getClientsEmailAction = (data) => {
  return { type: GET_USERS_EMAIL_REQUEST, payload: data };
};
export const getUserProgramGraph = (data) => {
  return { type: GET_USER_PROGRAM_GRAPH_REQUEST, payload: data };
};
export const getUserWatchGraph = (data) => {
  return { type: GET_USER_WATCH_GRAPH_REQUEST, payload: data };
};

export const getMaintenanceModeStatus = () => {
  return { type: GET_MAINTENANCE_MODE_REQUEST };
};

export const maintenanceModeStatus = (data) => {
  return { type: MAINTENANCE_MODE_REQUEST, payload: data };
};
